import React, {Component} from 'react';
import './confirmAuth.scss'
export default class confirmAuth extends Component {
  render() {    
    return (
      <div className="page-confirm-auth">
        Hello confirmAuth
      </div>
    )
  }
}